import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, X, ArrowRight } from 'lucide-react';

interface UnsavedChangesModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({ show, onCancel, onConfirm }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-sm">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-96 border border-gray-200">
        <div className="text-center mb-6">
          <div className="mx-auto w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            {t('common.unsavedChanges')}
          </h2>
          <p className="text-gray-600">
            {t('common.unsavedChangesMessage')}
          </p>
        </div>
        <div className="flex justify-center space-x-4">
          <button
            className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors duration-200 font-medium"
            onClick={onCancel}
          >
            <X size={16} />
            {t('common.cancel')}
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2.5 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors duration-200 font-medium"
            onClick={onConfirm}
          >
            <ArrowRight size={16} />
            {t('common.continue')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
